export const renderStatusName = (status) => {
  switch (status) {
    case 1:
      return 'پیش نویس';
    case 2:
      return 'منتظر بررسی';
    case 3:
      return 'فعال';
    case 4:
      return 'رد شده';
    case 5:
      return 'غیر فعال (جایگاه غیر فعال)';
    default:
      return 'نامشخص';
  }
};

export const renderStatusColor = (status) => {
  switch (status) {
    case 1:
      return '#FFC031';
    case 2:
      return '#FFC031';
    case 3:
      return 'green';
    case 4:
      return '#E50450';
    default:
      return '#E50450';
  }
};
